import React, { useState, useEffect } from "react";
import { Flame, TrendingUp, ChevronDown, ChevronUp } from "lucide-react";

// 1. Blog Data
const blogs = [
  {
    title: "India’s Trade Accelerated Supply Chains",
    category: "Global Trade",
    image: "https://img.freepik.com/premium-photo/business-technology-media-internet-people-concept-close-up-woman-with-blog-web-page-tablet-pc-computer-screen-coffee-wooden-table_380164-146500.jpg?semt=ais_hybrid&w=740&q=80",
    url: "#",
  },
  {
    title: "Technology Driving Indian Enterprises",
    category: "Digital Growth",
    image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d",
    url: "#",
  },
  {
    title: "Future of B2B Marketplaces in India",
    category: "Logistics",
    image: "https://images.unsplash.com/photo-1556761175-4b46a572b786",
    url: "#",
  },
  {
    title: "How MSMEs Are Going Global",
    category: "Business Strategy",
    image: "https://fastercapital.com/i/Market-Expansion--How-to-Expand-Your-Market-Reach-and-Scale-Your-Business--Developing-a-Market-Expansion-Strategy.webp",
    url: "#",
  },
  {
    title: "Digital Transformation Helping MSMEs Scale Faster",
    category: "B2B Insights",
    image: "https://blog.shift4shop.com/hubfs/iStock-1035778336.jpg",
    url: "#",
  },
  {
    title: "Future of Transportation & Logistics for MSMEs",
    category: "Supply Chain",
    image: "https://jdwarehouse.net/wp-content/uploads/2024/07/Future-of-Transportation-and-Logistics.png",
    url: "#",
  },
  {
    title: "Building Strong Business Networks for MSME Growth",
    category: "Work Culture",
    image: "https://www.shutterstock.com/shutterstock/photos/1934950961/display_1500/stock-photo-business-network-concept-management-strategy-human-resources-1934950961.jpg",
    url: "#",
  },
  {
    title: "B2B vs B2C Strategies: What MSMEs Should Know",
    category: "Finance",
    image: "https://www.shutterstock.com/shutterstock/photos/2350300813/display_1500/stock-photo-b-c-business-to-customer-marketing-strategy-woman-working-on-laptop-computers-with-b-c-icons-2350300813.jpg",
    url: "#",
  },
  {
    title: "Global Logistics Networks Empowering Small Businesses",
    category: "Marketing",
    image: "https://img.freepik.com/free-photo/global-logistics-transportation-network_23-2152005448.jpg?semt=ais_hybrid&w=740&q=80",
    url: "#",
  },
  {
    title: "How Team Collaboration Drives MSME Success",
    category: "Team Management",
    image: "https://thumbs.dreamstime.com/b/staff-meeting-office-4687523.jpg",
    url: "#",
  },
  {
    title: "Smart Passive Income Ideas for MSME Owners",
    category: "Finance",
    image: "https://adsterra.com/blog/wp-content/uploads/2022/04/Smart-Passive-Income-homepage.jpg",
    url: "#",
  },
  {
    title: "SEO Strategies MSMEs Can Use to Grow Online",
    category: "Digital Marketing",
    image: "https://thumbs.dreamstime.com/b/woman-working-seo-icon-young-female-entrepreneur-button-futuristic-screen-concept-search-engine-optimization-89727364.jpg",
    url: "#",
  },
];

const Blog: React.FC = () => {
  const [isAdOpen, setIsAdOpen] = useState(false);

  // Ad ko thodi der baad automatic slide karne ke liye
  useEffect(() => {
    const timer = setTimeout(() => setIsAdOpen(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="bg-[#050505] text-white overflow-x-hidden relative">

      {/* --- 1. HERO SECTION --- */}
      <section className="relative h-[60vh] w-full flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&q=80&w=2000"
            className="w-full h-full object-cover opacity-40 scale-110"
            alt="Hero"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black via-transparent to-[#050505]"></div>
        </div>
        <div className="relative z-10 text-center px-6">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="h-[1px] w-12 bg-[#008b7a]"></span>
            <span className="text-[#008b7a] font-black uppercase tracking-[0.6em] text-xs">Trady Frog Intelligence</span>
            <span className="h-[1px] w-12 bg-[#008b7a]"></span>
          </div>
          <h1 className="text-[10vw] md:text-[100px] font-[1000] leading-none tracking-[-0.05em] mb-6">
            <span className="inline-block">TRADY</span>
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#2e3192] to-[#008b7a] inline-block">FROG</span>
          </h1>
          <p className="max-w-2xl mx-auto text-xl text-slate-400 font-medium italic">
            "Empowering Global Trade through Strategic Intelligence."
          </p>
        </div>
      </section>

      {/* --- 2. TRENDING MARQUEE --- */}
      <div className="bg-white text-black py-4 overflow-hidden flex whitespace-nowrap border-y border-black/5 relative z-20">
        <div className="flex animate-marquee items-center gap-20">
          {[ "Global Trade Insights 2026", "Supply Chain Optimization", "Export-Import Trends", "Market Intelligence Report", "Logistics Innovation", "MSME Growth Strategies", "Digital Commerce Revolution" ].map((text, i) => (
            <div key={i} className="flex items-center gap-4">
              <Flame size={20} className="text-[#2e3192]" />
              <span className="font-black uppercase text-sm tracking-widest">{text}</span>
              <TrendingUp size={20} className="text-[#008b7a]" />
            </div>
          ))}
          {[ "Global Trade Insights 2026", "Supply Chain Optimization", "Export-Import Trends", "Market Intelligence Report", "Logistics Innovation", "MSME Growth Strategies", "Digital Commerce Revolution" ].map((text, i) => (
            <div key={i + 10} className="flex items-center gap-4">
              <Flame size={20} className="text-[#2e3192]" />
              <span className="font-black uppercase text-sm tracking-widest">{text}</span>
              <TrendingUp size={20} className="text-[#008b7a]" />
            </div>
          ))}
        </div>
      </div>

      {/* --- 3. BLOG SECTION --- */}
      <section className="bg-white pb-32">
        <div className="max-w-7xl mx-auto px-6 py-20">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {blogs.map((blog, index) => (
              <article key={index} className="bg-white rounded-2xl overflow-hidden border border-slate-100 shadow-sm hover:shadow-xl hover:translate-y-[-6px] transition duration-300">
                <a href={blog.url} className="block overflow-hidden">
                  <img src={blog.image} alt={blog.title} className="h-48 w-full object-cover hover:scale-110 transition duration-500" />
                </a>
                <div className="p-5">
                  <p className="text-xs uppercase tracking-widest text-[#008b7a] mb-2 font-bold">{blog.category}</p>
                  {/* Heading is now Clickable */}
                  <a href={blog.url} className="hover:text-[#008b7a] transition-colors">
                    <h3 className="text-sm font-bold leading-snug text-slate-800">{blog.title}</h3>
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* --- 4. STICKY BOTTOM AD WITH TOGGLE ARROW --- */}
      <div 
        className={`fixed bottom-0 left-0 w-full z-[100] transform transition-transform duration-500 ease-in-out flex flex-col items-center mb-0 ${
          isAdOpen ? "translate-y-0" : "translate-y-[80px] md:translate-y-[96px]"
        }`}
      >
        {/* Toggle Arrow Button */}
        <button 
          onClick={() => setIsAdOpen(!isAdOpen)}
          className="bg-white border border-slate-200 border-b-0 px-4 py-1 rounded-t-lg shadow-md flex items-center justify-center text-slate-600 hover:text-red-600 transition-colors"
        >
          {isAdOpen ? <ChevronDown size={20} /> : <ChevronUp size={20} />}
        </button>
{/* Ad Content Container */}
<div className="w-full max-w-5xl bg-[#1a0b3b] h-20 md:h-24 flex items-center relative border-t border-white/10 shadow-2xl overflow-hidden">
  <div className="flex items-center w-full px-4 md:px-10 gap-4 md:gap-8">
    
    {/* Brand Side - Updated from Semrush to TRADYFROG */}
    <div className="flex items-center gap-3 border-r border-white/10 pr-6 hidden md:flex">
      <div className="w-8 h-8 bg-green-500 rounded flex items-center justify-center font-bold text-white text-xs">
        T
      </div>
      <span className="font-bold text-white tracking-tighter uppercase text-sm">TRADYFROG</span>
    </div>

    {/* Promo Text */}
    <div className="flex-1">
      <h4 className="text-white font-bold text-sm md:text-lg leading-tight">
        Scale your <span className="text-blue-400">Global Trade</span> with AI
      </h4>
      <p className="text-white/60 text-[10px] md:text-xs font-medium">
        Get real-time insights and grow your business faster today.
      </p>
    </div>

    {/* Action Button */}
    <div className="flex items-center">
      <button className="bg-orange-500 hover:bg-orange-600 text-white font-black px-4 md:px-8 py-2 md:py-3 rounded-md text-[10px] md:text-xs transition-all uppercase tracking-wider">
        Get Started
      </button>
    </div>
  </div>
  <div className="absolute right-0 top-0 h-full w-1/3 bg-gradient-to-l from-blue-600/10 to-transparent pointer-events-none"></div>
</div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 30s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default Blog;